export const UserStatus = {
  VERIFIED: "verified",
  UNVERIFIED: "unverified",
  REJECTED: "rejected",
} as const;

export type UserStatusValue = (typeof UserStatus)[keyof typeof UserStatus];

export const StatusFilter = {
  ALL: "all",
  UNVERIFIED: UserStatus.UNVERIFIED,
  REJECTED: UserStatus.REJECTED,
  VERIFIED: UserStatus.VERIFIED,
} as const;

export type StatusFilterValue = (typeof StatusFilter)[keyof typeof StatusFilter];
